/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUploadResp } from '../../models/file-upload-resp';

export interface ApiFilePost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiFilePost(http: HttpClient, rootUrl: string, params?: ApiFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResp>> {
  const rb = new RequestBuilder(rootUrl, apiFilePost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUploadResp>;
    })
  );
}

apiFilePost.PATH = '/api/file';
